document.addEventListener('DOMContentLoaded', function () {
    /* Only run on the homepage */
    if (!document.body.classList.contains('template-index')) return;

    var sections = Array.from(document.querySelectorAll('#main > .shopify-section'));
    if (sections.length === 0) return;

    var STICKY_TOP = 0;
    var viewH = 0;
    var tops = [];
    var footerModule = document.querySelector('#shopify-section-footer');
    
    var wrappers = sections.map(function (section) {
        return section.querySelector('.text-wrapper, .video-wrapper__poster-content');
    });

    
    /* Extract text from the first banner to create the standalone parallax sticky text */
    var citywalkTextEl = null;
    var citywalkWrapper = null;
    if (sections[0]) {
        var firstContentBox = sections[0].querySelector('.content-box');
        if (firstContentBox) {
            
            citywalkTextEl = document.createElement('div');
            citywalkTextEl.className = 'citywalk-text';
            citywalkTextEl.innerHTML = '<div class="text-wrapper">' + firstContentBox.innerHTML + '</div>';
            
            /* Remove any native theme animation attributes that might hide the cloned content */
            var revealedEls = citywalkTextEl.querySelectorAll('[reveal]');
            for (var j = 0; j < revealedEls.length; j++) {
                revealedEls[j].removeAttribute('reveal');
                revealedEls[j].style.opacity = '1';
                revealedEls[j].style.transform = 'none';
            }
            var hiddenEls = citywalkTextEl.querySelectorAll('[reveal-visibility]');
            for (var j = 0; j < hiddenEls.length; j++) {
                hiddenEls[j].removeAttribute('reveal-visibility');
            }

            sections[0].parentNode.insertBefore(citywalkTextEl, sections[0]);

            
            citywalkWrapper = citywalkTextEl.querySelector('.text-wrapper');
            firstContentBox.style.opacity = '0';
            firstContentBox.style.pointerEvents = 'none';
        }
    }

    /* Build z-index stack: citywalk section, citywalk-text overlay, remaining sections, footer */
    var stickyStack = [sections[0]];
    if (citywalkTextEl) stickyStack.push(citywalkTextEl);
    stickyStack = stickyStack.concat(sections.slice(1));
    if (footerModule) stickyStack.push(footerModule);
    stickyStack = stickyStack.filter(Boolean);


    stickyStack.forEach(function (el, i) {
        el.style.zIndex = i + 1;
        if (el !== citywalkTextEl) {
            el.style.position = 'sticky';
        }
        /* citywalkTextEl keeps position:fixed from CSS */
    });

    function computeStickyTops() {
        var annBarSection = document.querySelector('.shopify-section--announcement-bar');
        var navHeaderSection = document.querySelector('.shopify-section--header');

        /* The Focal theme sets style.top="0px" on these sections during init, which
           overrides the CSS variable calc(--enable-sticky-announcement-bar * --announcement-bar-height)
           that correctly positions the nav below the announcement bar. Remove it. */
        if (annBarSection) annBarSection.style.removeProperty('top');
        if (navHeaderSection) navHeaderSection.style.removeProperty('top');

        /* Calculate true total header height from actual sticky sections */
        var annBarH = annBarSection ? annBarSection.offsetHeight : 0;
        var navH = navHeaderSection ? navHeaderSection.offsetHeight : 0;
        STICKY_TOP = annBarH + navH;
        if (STICKY_TOP === 0) {
            STICKY_TOP = window.innerWidth <= 900 ? 65 : 88;
        }

        viewH = window.innerHeight;

        /* Hero parallax: negative sticky top lets the full-height hero image scroll through
           the viewport before the section sticks — matching the US site's parallax behaviour.
           When stuck, the hero bottom aligns with the viewport bottom, showing the image end.
           Math.min(0, ...) guards against positive values if the section is shorter than viewport. */
        var heroH = sections[0].offsetHeight;
        var heroParallaxTop = Math.min(0, -(heroH - viewH));

        tops = sections.map(function (section, i) {
            return i === 0 ? heroParallaxTop : STICKY_TOP;
        });

        sections.forEach(function (section, i) {
            section.style.top = tops[i] + 'px';
        });

        /* Pull hero up so it fills right below the header on initial load */
        sections[0].style.marginTop = '-' + STICKY_TOP + 'px';

        if (footerModule) { footerModule.style.position = 'sticky'; footerModule.style.top = STICKY_TOP + 'px'; }
    }

    function updateOpacities() {
        if (!viewH) return;

        
        /* Hide the citywalk overlay once the second section slides over it */
        if (citywalkWrapper && sections[1]) {
            var nextSection = sections[1];
            citywalkWrapper.style.opacity = (nextSection.getBoundingClientRect().top <= STICKY_TOP + 1) ? '0' : '1';
        }

        var fadeStart = viewH - 100;

        sections.forEach(function (section, i) {
            var wrapper = wrappers[i];
            if (!wrapper) return;

            var sectionTop = section.getBoundingClientRect().top;
            var pinnedTop  = tops[i] !== undefined ? tops[i] : STICKY_TOP;
            var progress   = (fadeStart - sectionTop) / ((fadeStart - pinnedTop) * 0.8);
            wrapper.style.opacity = Math.max(0, Math.min(1, progress));
        });
    }

    function opacityLoop() {
        updateOpacities();
        requestAnimationFrame(opacityLoop);
    }
    requestAnimationFrame(opacityLoop);

    window.addEventListener('load', function () {
        viewH = window.innerHeight;
        computeStickyTops();
    });

    window.addEventListener('resize', computeStickyTops);
    
    computeStickyTops(); // initial call
});

try {
    var lenis = new Lenis({
        lerp: 0.12,
        wheelMultiplier: 1.0,
        infinite: false,
        gestureOrientation: 'vertical',
        normalizeWheel: false,
        smoothTouch: false
    });

    function raf(time) {
        lenis.raf(time);
        requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);
} catch (e) {
    console.warn('Lenis failed to initialize', e);
}
